<template>
  <router-view/>
</template>

<style>
:root{
  --primary-1: #0090c6;
  --primary-2: #3CBAAF;
  --primary-3: #034057;
  --secondary-1: #EDF0F5;
  --secondary-2: #40ADCE;
  --success: #59DACF;
  --alert: #D43A33;
  --header-font: #034057;
  --dark-font: #000000;
  --light-font: #FFFFFF
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  font-weight: bold !important;
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: var(--dark-font);
}

nav a.router-link-exact-active {
  color: #42b983;
}

@import url('https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100..900;1,100..900&display=swap');
#app{
  font-family: "Roboto", sans-serif;
}

.v-table > .v-table__wrapper > table {
  border-collapse: separate;
  border-spacing: 0 10px !important;
}

.v-data-table__thead{
  background-color: var(--primary-3) !important;
  color: white;
}

.v-data-table__tr{
  background-color: var(--secondary-1);
  border-radius: 15px;
}

.v-data-table__td{
  padding: 15px !important;
}

.v-data-table__td:first-child{
  border-radius: 10px 0 0 10px;
}

.v-data-table__td:last-child{
  border-radius: 0 10px 10px 0;
}

.v-data-table__th--sortable:hover {
  color: var(--light-font) !important;
}

.v-table__wrapper > table > thead{
  background-color: var(--primary-3);
  color: white;
}

.v-table__wrapper > table > tbody > tr{
  background-color: var(--secondary-1);
  border-radius: 15px;
}

.primary-button{
  background: var(--primary-2) !important;
  color: white !important;
  border-radius: 15px !important;
}

.primary-button:hover{
  background: var(--success) !important;
}

.secondary-button{
  background: var(--alert) !important;
  color: white !important;
  border-radius: 15px !important;
}

.v-icon{
  color: var(--primary-1);
}

.v-toolbar{
  background-color: var(--primary-1) !important;
  color: var(--light-font) !important;
}

.v-field__outline{
  border-radius: 25px !important;
}

.v-field--variant-outlined .v-field__outline__start{
  flex: 0 0 25px !important;
}

.save-btn{
  background: linear-gradient(90deg, var(--primary-1) 0%, var(--secondary-2) 100%) !important;
  color: var(--light-font) !important;
  border-radius: 10px !important;
}

.cancel-btn{
  background-color: var(--alert) !important;
  color: var(--light-font) !important;
  border-radius: 10px !important;
}

.primary-btn{
  background: linear-gradient(90deg, var(--primary-1) 0%, var(--secondary-2) 100%) !important;
  color: var(--light-font) !important;
  border-radius: 10px !important;
}

.v-data-table-footer__items-per-page > .v-input > .v-input__control > .v-field > .v-field__outline {
    background-color: var(--secondary-1) !important;
    overflow: hidden;
    z-index: -1;
}

.v-field__outline::before{
  border-width: 0;
}

.v-field__outline::after{
  border-width: 0;
}
</style>
